import { jwtDecode } from "jwt-decode";
import useApiService from "./useApiService";

const useAuth = () => {
  const { get, post } = useApiService();

  const requestOtp = async (mobile) => {
    try {
      const response = await post("/api/auth/otp/request", { mobile });
      if (!response.status) throw new Error("Failed to request OTP");

      return { success: `OTP sent to ${mobile}` };
    } catch (error) {
      return { error };
    }
  };

  const verifyOtp = async (mobile, otp) => {
    try {
      const response = await post("/api/auth/otp/verify", { mobile, otp });

      if (!response.status) throw new Error("Failed to verify OTP");

      const { token, user } = response;
      if (!token) throw new Error("Token not found in response");

      localStorage.setItem("authToken", token);
      localStorage.setItem("user", JSON.stringify(user));

      return { success: "OTP verified successfully" };
    } catch (error) {
      return { error };
    }
  };

  const verifyDeleteOtp = async (mobile, otp, userType) => {
    try {
      const response = await post("/api/auth/otp/validate-otp", { mobile, otp, user_type: userType });
      if (!response.status) throw new Error("Failed to verify OTP");
      return { success: "Account deleted successfully" };
    } catch (error) {
      return { error };
    }
  };

  const logout = async () => {
    try {
      const response = await post("/api/auth/logout");
      if (!response.status) throw new Error("Failed to logout");
      localStorage.clear();

      return { success: "Logged out successfully" };
    } catch (error) {
      localStorage.clear();
      return { error };
    }
  };

  const validateAuth = async () => {
    const authToken = localStorage.getItem("authToken");
    if (!authToken) return false;

    const { exp } = jwtDecode(authToken);
    // if (Date.now() < exp * 1000) return true;
    return Date.now() < exp * 1000;

    // try {
    //   const response = await get("/api/session-status");

    //   if (!response.status) throw new Error("Session validation failed");

    //   const { token, user } = response;
    //   if (!token) throw new Error("Token not found in response");

    //   localStorage.setItem("authToken", token);
    //   localStorage.setItem("user", JSON.stringify(user));
    //   return true;
    // } catch (error) {
    //   localStorage.clear();
    //   return false;
    // }
  };

  return { requestOtp, verifyOtp, logout, validateAuth, verifyDeleteOtp };
};

export default useAuth;
